import {
  Component,
  OnInit,
  ElementRef,
  ViewChild,
  HostListener,
  AfterViewInit,
  ChangeDetectorRef,
  NgZone,
  AfterViewChecked,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { PlayBoardService } from '../../../shared/services/play-board.service';
import {
  ChessboardFun,
  chessBoard,
  clearCanvas,
  drawArrow,
  getLatestPosition,
  initializeCanvas,
  rotateChess,
} from '../../../shared/functions/chessboardMain';
import { joinGame, socket } from '../../../shared/helpers/socketio';
import { io } from 'socket.io-client';
import { environment } from '../../../../../environments/environment';
import { game } from '../../../shared/functions/chess';

import {
  getEliminatedPieces,
  highlightLastMove,
  moveBlock,
  resetChess,
  undoMove,
  updateBoard,
} from '../../../shared/functions/onDrop';
import { Chess } from '../../../shared/js';
import { PieceIconPipe } from '../../../shared/pipes/piece-icon.pipe';
import { Subscription, interval } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { CommonServiceService } from '../../../shared/services/common-service.service';
import {
  trigger,
  style,
  transition,
  animate,
  keyframes,
} from '@angular/animations';
import { DecryptionService } from '../../../shared/services/decryption.service';
declare var $: any;

@Component({
  selector: 'app-start-play',
  standalone: true,
  templateUrl: './start-play.component.html',
  styleUrl: './start-play.component.scss',
  imports: [CommonModule, PieceIconPipe],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        animate(
          '2s ease-out',
          keyframes([
            style({ transform: 'translateY(-100vh)', offset: 0 }),
            style({ transform: 'translateY(0)', offset: 0.5 }),
            style({ opacity: 1, offset: 1 }),
          ])
        ),
      ]),
      transition(':leave', [animate('2s ease-in', style({ opacity: 0 }))]),
    ]),
  ],
})
export class StartPlayComponent
  implements OnInit, AfterViewInit, AfterViewChecked
{
  @ViewChild('moveScrollContainerVertical')
  private moveScrollContainerVertical: any;
  @ViewChild('moveScrollContainerHorizontal')
  private moveScrollContainerHorizontal: any;
  playListStart!: string | null;
  socket: any = io(environment.socketUrl);
  gameData: any;
  loginUserId: any;
  moves!: string[];
  displayStyle2 = 'none';
  ConfirmResignation = 'none';
  isDrawPopup = 'none';
  playerColortimeOut: any;
  drawId: any;
  reMatchrequest = false;
  completeDraw!: boolean;
  checkmate: any;
  winnerPlayer: any;
  gamefinishData: any;
  drawbtn: boolean = false;
  aiplayer: any;
  currentIndex!: number;
  drawSentRequest!: string;
  lastIndexGame: any;
  whiteUpdateRating: any;
  blackUpdateRating: any;
  blackDetailsRating: any;
  whiteDetailsRating: any;
  isFlipped!: boolean;
  moveBtn = false;
  whiteSideTimer: string = '';
  blackSideTimer: string = '';
  finishGameData: any;
  boardModeimg = '';
  private localTimerSubscription!: Subscription;
  lastUpdate!: number;
  whiteCurrentTime!: number;
  blackCurrentTime!: number;
  remacthDenied = '';
  cupturedData: any[] = [];
  eliminatedList: any = [];
  loadingrematch: boolean = false;
  showAnimation: boolean = false;
  player1Name: string = 'Player 1';
  player2Name: string = 'Player 2';
  player1Image: string = '';
  player2Image: string = '';
  isAborted: boolean = false;
  newMatchMakingGame: boolean = false;
  private socketListener!: () => void;
  public eliminatedWhitePiecesCount: { [key: string]: number } = {};
  public eliminatedBlackPiecesCount: { [key: string]: number } = {};

  constructor(
    private playService: PlayBoardService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private elRef: ElementRef,
    private toasterapi: CommonServiceService,
    private toastr: ToastrService,
    private ngZone: NgZone,
    private cdref: ChangeDetectorRef,
    private decryptionApi: DecryptionService
  ) {
    this.toasterapi.challangeRequest$.subscribe((res) => {
      this.ngZone.run(() => {
        if (res.rejectReq) {
          this.remacthDenied = 'Rematch Denied.';
          this.loadingrematch = false;
          cdref.detectChanges();
        }
      });
    });
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  ngOnInit() {
    this.playListStart = this.activatedRoute.snapshot.paramMap.get('id');
    this.startLocalTimer();
    this.joinUserdata(this.playListStart);

    // socket.on('sendChallange', (data: any) => {
    //   if (data) {
    //     this.displayStyle2 = 'none';
    //   }
    // });

    socket.on('timeUpdates', (data: any) => {
      this.updateTimers(data);
    });
  }

  ngOnDestroy(): void {
    this.cleanupSubscriptions();
    chessBoard.destroy();
  }

  ngAfterViewInit(): void {
    ChessboardFun();
    resetChess();

    joinGame(this.playListStart);
    initializeCanvas(this.elRef);
    this.aiplayer = JSON.parse(localStorage.getItem('gameIdreponse') || '{}');
    socket.on('newMove', (data: any) => {
      this.isDrawPopup = 'none';
      this.moves = this.parsePGN(data);

      if (this.moves?.length > 0) {
        this.drawbtn = true;
      }

      if (this.gameData?.status !== 'completed') {
        game.loadPgn(data);
        chessBoard.position(game.fen());
        const moves: any = game.history({ verbose: true });
        this.lastIndexGame = this.moves?.length;
        this.currentIndex = this.lastIndexGame;

        this.eliminatedPieceData();
        const lastMove = moves.length ? moves[moves.length - 1] : null;
        highlightLastMove(lastMove.from, lastMove.to);
        updateBoard();
      }

      this.eliminatedList = getEliminatedPieces(game.fen());

      if (data) {
        $('#gamecontinue').hide();
      }

      if (game.isGameOver()) {
        this.drawbtn = false;
        this.displayStyle2 = 'block';
        const gamedetails = JSON.parse(
          localStorage.getItem('gameIdreponse') || '{}'
        );

        if (game.isCheckmate()) {
          const winner = game.turn() === 'w' ? 'Black' : 'White';
          this.checkmate = 'checkmate';
          this.winnerPlayer =
            winner === 'Black'
              ? gamedetails.blackSidePlayer
              : gamedetails.whiteSidePlayer;
        } else if (game.isDraw()) {
          this.checkmate = 'draw';
        }

        this.endgameData();
      }
    });

    socket.on('sendDraw', (data: any) => {
      this.drawSentRequest = data;
      this.completeDraw = false;
      if (data.username != this.loginUserId.username) {
        if (
          this.loginUserId?.username === this.gameData?.whiteSidePlayer ||
          this.loginUserId?.username === this.gameData?.blackSidePlayer
        ) {
          this.isDrawPopup = 'block';
        }
      }
    });

    socket.on('receiveDraw', (data: any) => {
      if (data === 'true') {
        this.checkmate = 'draw';
        this.endgameData();
        this.displayStyle2 = 'block';
      } else if (data === 'false') {
        this.completeDraw = true;
      }
      this.isDrawPopup = 'none';
    });

    socket.on('getResign', (data: any) => {
      let gamedetails = JSON.parse(
        localStorage.getItem('gameIdreponse') || '{}'
      );
      this.winnerPlayer =
        data.username === gamedetails.blackSidePlayer
          ? gamedetails.whiteSidePlayer
          : gamedetails.blackSidePlayer;

      this.checkmate = 'resign';
      this.displayStyle2 = 'block';
      this.endgameData();
      this.cdref.detectChanges();
    });

    socket.on('abortGame', (data: any) => {
      this.isAborted = true;
      this.displayStyle2 = 'block';
    });
  }

  ngAfterViewChecked() {
    this.scrollToCurrentMove(this.moveScrollContainerVertical);
    this.scrollToCurrentMove(this.moveScrollContainerHorizontal);
  }

  isCriticalTime(side: 'black' | 'white'): boolean {
    const time =
      side === 'white' ? this.whiteCurrentTime : this.blackCurrentTime;
    return time < 10;
  }

  getPieceCounts(pieces: string[]): any {
    const counts: any = {
      '♙': 0,
      '♕': 0,
      '♘': 0,
      '♗': 0,
      '♖': 0,
    };

    pieces.forEach((piece) => {
      const lowerCasePiece = piece.toLowerCase();
      switch (lowerCasePiece) {
        case 'p':
          counts['♙']++;
          break;
        case 'q':
          counts['♕']++;
          break;
        case 'n':
          counts['♘']++;
          break;
        case 'b':
          counts['♗']++;
          break;
        case 'r':
          counts['♖']++;
          break;
      }
    });
    return counts;
  }

  getFormattedPiecesList(pieceCounts: { [key: string]: number }): string[] {
    const result: any = [];
    for (const [piece, count] of Object.entries(pieceCounts)) {
      if (count > 0) {
        // Repeat the piece symbol 'count' times
        const repeatedPieces = piece.repeat(count);
        result.push(repeatedPieces);
      }
    }
    return result;
  }

  updateTimers(data: any): void {
    this.whiteCurrentTime = data.whitesCurrentTime;
    this.blackCurrentTime = data.blacksCurrentTime;
    this.lastUpdate = Date.now();
  }

  formatTimes(time: any): string {
    if (isNaN(time) || time === null || time === undefined) {
      return this.gameData?.time;
    }

    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }

  scrollToCurrentMove(containerRef: ElementRef) {
    if (containerRef) {
      const container = containerRef.nativeElement;
      const selectedMove = container.querySelector('.selected-move');
      if (selectedMove) {
        const containerHeight = container.clientHeight;
        const containerWidth = container.clientWidth;
        const moveHeight = selectedMove.clientHeight;
        const moveWidth = selectedMove.clientWidth;
        const offsetTop = selectedMove.offsetTop - container.offsetTop;
        const offsetLeft = selectedMove.offsetLeft - container.offsetLeft;

        // Scroll to the position that centers the selected move in the container
        container.scrollTop = offsetTop - containerHeight / 2 + moveHeight / 2;
        container.scrollLeft = offsetLeft - containerWidth / 2 + moveWidth / 2;
      }
    }
  }

  cleanupSubscriptions(): void {
    if (this.socketListener) {
      this.socketListener();
    }
    if (this.localTimerSubscription) {
      this.localTimerSubscription.unsubscribe();
    }
  }

  startLocalTimer(): void {
    this.localTimerSubscription = interval(10).subscribe(() => {
      const now = Date.now();
      const elapsed = Math.floor((now - this.lastUpdate) / 1000);

      if (elapsed > 0) {
        this.whiteCurrentTime = Math.max(0, this.whiteCurrentTime - elapsed);
        this.blackCurrentTime = Math.max(0, this.blackCurrentTime - elapsed);
        this.lastUpdate = now;
      }

      this.whiteSideTimer = this.formatTimes(this.whiteCurrentTime);
      this.blackSideTimer = this.formatTimes(this.blackCurrentTime);

      if (this.whiteSideTimer === '0:00' || this.blackSideTimer === '0:00') {
        if (this.whiteSideTimer === '0:00') {
          this.handlePlayerLose(this.gameData.whiteSidePlayer);
        }
        if (this.blackSideTimer === '0:00') {
          this.handlePlayerLose(this.gameData.blackSidePlayer);
        }
        this.endgameData();
      }
    });
  }

  resignGame() {
    this.ConfirmResignation = 'block';
    this.isDrawPopup = 'none';
  }

  confirmResign() {
    socket.emit('resign', this.loginUserId);
    this.ConfirmResignation = 'none';
  }

  confirmresignClose() {
    this.ConfirmResignation = 'none';
  }

  stopTimersocket() {
    this.cleanupSubscriptions();
    socket.emit('stopTimer', {
      gameId: this.playListStart,
      username: this.loginUserId.username,
    });
  }

  endgameData() {
    this.ConfirmResignation = 'none';
    this.isDrawPopup = 'none';
    var endgamesData = {
      gameId: this.playListStart,
      drawBY: this.checkmate === 'draw' ? this.drawSentRequest : undefined,
      winner:
        this.checkmate === 'resign' ? this.winnerPlayer : this.winnerPlayer,
      wonBY: this.checkmate,
    };

    moveBlock(this.checkmate);
    this.stopTimersocket();
    if (this.loginUserId.username === this.gameData.whiteSidePlayer) {
      this.playService.endgameData(endgamesData).subscribe((res) => {});
    }
    this.drawbtn = false;
    this.moveBtn = true;
    this.moves = this.parsePGN(game.pgn());
    this.finishGameData = game.pgn();
    this.lastIndexGame = this.moves?.length;
    this.currentIndex = this.lastIndexGame;

    setTimeout(() => {
      this.ratingDetails();
    }, 1000);
  }

  ratingDetails() {
    this.playService.newRatingData(this.playListStart).subscribe({
      next: (res) => {
        const decrypt = this.decryptionApi.decrypt(res.payload);
        const jsondecrpt = JSON.parse(decrypt);
        const calculateRatingDifference = (
          newRating: number,
          oldRating: number
        ) => {
          const difference = newRating - oldRating;
          return difference > 0 ? `+${difference}` : `${difference}`;
        };

        this.whiteDetailsRating = calculateRatingDifference(
          jsondecrpt.white,
          this.whiteUpdateRating
        );

        this.blackDetailsRating = calculateRatingDifference(
          jsondecrpt.black,
          this.blackUpdateRating
        );
      },
      error: (err) => {
        console.error('Rating data error:', err);
      },
    });
  }

  joinUserdata(data: any) {
    this.showAnimation = true;
    const joinuser = { gameId: data };
    this.playService.joingameData(joinuser).subscribe({
      next: (res) => {
        const decrypt = this.decryptionApi.decrypt(res.payload);
        const jsondecrpt = JSON.parse(decrypt);
        this.gameData = jsondecrpt;
        this.whiteUpdateRating = this.gameData.whiteSidePlayersCurrentRating;
        this.blackUpdateRating = this.gameData.blackSidePlayersCurrentRating;
        this.player1Name = this.gameData.whiteSidePlayer;
        this.player2Name = this.gameData.blackSidePlayer;
        this.player1Image =
          this.gameData.whiteSidePlayerImage ||
          '/assets/customer-image/men-shadow.png';
        this.player2Image =
          this.gameData.blackSidePlayerImage ||
          '/assets/customer-image/men-shadow.png';
        game.loadPgn(this.gameData.pgn);
        chessBoard.position(game.fen());
        updateBoard();
        this.moves = this.parsePGN(this.gameData.pgn);
        this.lastIndexGame = this.moves?.length;
        this.currentIndex = this.lastIndexGame;
        this.eliminatedPieceData();

        localStorage.setItem('gameIdreponse', JSON.stringify(this.gameData));
        let userDATA = JSON.parse(localStorage.getItem('loggedInUser') || '{}');
        this.loginUserId = userDATA;
        const isBlackSidePlayer =
          this.gameData.blackSidePlayer == userDATA.username;
        const isWhiteSidePlayer =
          this.gameData.whiteSidePlayer == userDATA.username;
        const isGameCompleted = this.gameData?.status == 'completed';

        if (this.gameData.blackSidePlayer == userDATA.username) {
          rotateChess();
          this.isFlipped = !this.isFlipped;
        }

        this.moveBtn = isGameCompleted;

        if (!isGameCompleted) {
          getLatestPosition(this.gameData.pgn);
        }
        if (this.moves.length > 0 && !isGameCompleted) {
          this.drawbtn = isBlackSidePlayer || isWhiteSidePlayer;
        }

        moveBlock(this.gameData.status);
        this.selectedMode(this.gameData);

        if (this.gameData?.status !== 'completed' && this.moves.length < 1) {
          this.showAnimation = true;
          setTimeout(() => {
            this.showAnimation = false;
          }, 3000);
        } else {
          this.showAnimation = false;
        }
      },
      error: (error) => {
        this.toastr.error(error.error.message);
        this.router.navigate(['home']);
      },
    });
  }

  eliminatedPieceData() {
    this.eliminatedList = getEliminatedPieces(game.fen());
    this.eliminatedWhitePiecesCount = this.getPieceCounts(
      this.eliminatedList.white
    );
    this.eliminatedBlackPiecesCount = this.getPieceCounts(
      this.eliminatedList.black
    );
  }

  formatTime(time: number): string {
    const minutes: string = Math.floor(time / 60)
      .toString()
      .padStart(2, '0');
    const seconds: string = (time % 60).toString().padStart(2, '0');
    return `${minutes}:${seconds}`;
  }

  handlePlayerLose(playerColor: string) {
    this.displayStyle2 = 'block';
    this.playerColortimeOut = `Player ${playerColor} has lost the game due to timeout.`;
    let gamedetails = JSON.parse(localStorage.getItem('gameIdreponse') || '{}');
    this.winnerPlayer =
      playerColor == gamedetails.blackSidePlayer
        ? gamedetails.whiteSidePlayer
        : gamedetails.blackSidePlayer;

    this.checkmate = 'Timeout';
  }

  closegameOver() {
    this.displayStyle2 = 'none';
    if (this.isAborted) {
      this.router.navigate(['play']);
    }
    // window.location.reload();
  }

  abortGame() {
    socket.emit('abort', this.playListStart);
    this.playService.deleteGameData({ gameId: this.playListStart }).subscribe({
      next: (res) => {},
    });
  }

  drawGame() {
    this.drawId = this.loginUserId;
    socket.emit('draw', this.loginUserId);
    if (this.aiplayer.player === false) {
      setTimeout(() => {
        this.drawAccess('true');
        this.drawbtn = false;
        game.isDraw();
      }, 1000);
    }
  }

  drawAccess(data: string) {
    socket.emit('decideDraw', data);
  }

  drawReject(data: string) {
    socket.emit('decideDraw', data);
    $('#gamecontinue').show();
  }

  drawPopup() {
    this.completeDraw = false;
  }

  nextMove(): void {
    if (this.currentIndex < this.moves.length) {
      const move = this.moves[this.currentIndex];
      if (move === '1/2-1/2' || move === '1-0' || move === '0-1') {
        return;
      }
      game.move(move);

      chessBoard.position(game.fen());
      const moves: any = game.history({ verbose: true });
      const lastMove = moves.length ? moves[moves.length - 1] : null;
      highlightLastMove(lastMove?.from, lastMove?.to);
      drawArrow(lastMove?.from, lastMove?.to);
      updateBoard();
      this.currentIndex++;
    }
    this.eliminatedPieceData();
  }

  parsePGN(pgn: string): string[] {
    const movesArray: string[] = [];
    const moves = pgn.split(/\d+\./).slice(1);

    for (let move of moves) {
      const moveSequence = move.trim().split(/\s+/);
      for (let singleMove of moveSequence) {
        if (singleMove.trim() !== '') {
          movesArray.push(singleMove);
        }
      }
    }

    return movesArray;
  }

  prevMove() {
    if (this.currentIndex > 0) {
      clearCanvas();
      this.currentIndex--;
      undoMove();
      updateBoard();
      const moves: any = game.history({ verbose: true });
      const lastMove = moves.length ? moves[moves.length - 1] : null;
      if (lastMove) drawArrow(lastMove?.from, lastMove?.to);
    }
    this.eliminatedPieceData();
  }

  resetChessBoard() {
    this.currentIndex = 0;
    resetChess();
    updateBoard();
    this.eliminatedPieceData();
  }

  filpChessBoard() {
    this.isFlipped = !this.isFlipped;
    rotateChess();
    const moves: any = game.history({ verbose: true });
    const lastMove = moves.length ? moves[moves.length - 1] : null;
    if (lastMove) drawArrow(lastMove?.from, lastMove?.to);
  }

  endChessBoard() {
    this.currentIndex = this.lastIndexGame;
    game.loadPgn(this.gameData.pgn || this.finishGameData);
    chessBoard.position(game.fen());
    updateBoard();
    this.eliminatedPieceData();
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (this.gameData?.status == 'completed') {
      event.stopPropagation();
      if (
        event.key === 'ArrowLeft' ||
        event.key === 'ArrowUp' ||
        event.key === 'ArrowDown' ||
        event.key === 'ArrowRight' ||
        event.key === 'F' ||
        event.key === 'f' ||
        event.key === 'R' ||
        event.key === 'r'
      ) {
        event.preventDefault();
        if (event.key === 'ArrowLeft') {
          this.prevMove();
        } else if (event.key === 'ArrowRight') {
          this.nextMove();
        } else if (event.key === 'ArrowUp') {
          this.endChessBoard();
        } else if (event.key === 'ArrowDown') {
          clearCanvas();
          highlightLastMove();
          this.resetChessBoard();
        } else if (event.key === 'F' || event.key === 'f') {
          this.filpChessBoard();
        } else if (event.key === 'R' || event.key === 'r') {
          this.resetChessBoard();
        }
      }
    }
  }

  selectedMode(data: any) {
    const gameModeImages: any = {
      blitz: '/assets/icon-image/blitz-img.svg',
      bullet: '/assets/icon-image/bullet-img.svg',
      rapid: '/assets/icon-image/rapid-img.svg',
      puzzle: '/assets/sidebar-image/sidebar-puzzles-img.svg',
    };

    this.boardModeimg = gameModeImages[data.gameMode] || '';
  }

  getMove(data: any) {
    this.currentIndex = data;
    const movesUpToCurrentIndex = this.moves.slice(0, this.currentIndex + 1);
    const chess = new Chess();
    for (const move of movesUpToCurrentIndex) {
      chess.move(move);
    }
    const moves: any = chess.history({ verbose: true });
    const lastMove = moves.length ? moves[moves.length - 1] : null;
    if (lastMove) drawArrow(lastMove?.from, lastMove?.to);
    highlightLastMove(lastMove?.from, lastMove?.to);
    game.loadPgn(chess.pgn());
    chessBoard.position(game.fen());
    updateBoard();
    this.currentIndex++;
    this.eliminatedPieceData();
  }

  rematchReqeust(data: string) {
    this.loadingrematch = true;
    this.remacthDenied = '';
    let ratings = '';
    let sentrematchRequest =
      data != this.gameData.blackSidePlayer
        ? this.gameData.blackSidePlayer
        : this.gameData.whiteSidePlayer;

    const challangeData = {
      username: sentrematchRequest,
      time: this.gameData.time,
      rating: ratings,
      playedAS: data != this.gameData.blackSidePlayer ? 'W' : 'B',
      sentChallange: data,
      gameMode: this.gameData.gameMode,
      gameType: this.gameData.gametype,
      ratedGame: this.gameData.ratedGame,
    };

    socket.emit('challange', challangeData);
  }
}
